import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row, Modal, Radio } from 'antd';
import * as Axios from "axios";

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { HeadersComponent } from 'src/app/rules/rules/form/parts/executors/parts/headers-component';

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

interface WebHookExecutorProps {
	onFieldChange: (field: string, value: any) => void;
	values?: {[id:string]: any};
	mode: ControlMode;
}

interface WebHookExecutorState {
	response?: any;
	showPreviewModal: boolean;
	url: string;
	params: string;
	body: string;
	previewMode: 'html' | 'raw'
}

@observer
export class WebHookExecutor extends React.Component<WebHookExecutorProps, WebHookExecutorState> {
	constructor(props) {
		super(props);

		this.state = {
			showPreviewModal: false,
			url: this.props.values['url'],
			params: this.props.values['urlParams'],
			body: this.props.values['bodyTemplate'],
			previewMode: 'raw'
		};
	}

	decodeHeaders() {
		if (this.props.values) {

			const headers = this.props.values['headers'];

			if (!headers)
				return {};

			const tuples = headers.split('\r\n').map((item, index) => item.split(':'));

			var result = {};

			for (var tuple of tuples) {
				result[tuple[0]] = tuple[1];
			}

			return result;
		}
		return {}
	}

	@autobind
	testWebHook() {

		const values = this.props.values;
		if (values) {

			this.http = Axios.default.create({
				timeout: 30000,
				baseURL: values['url'],
			});

			const method: 'GET' | 'POST' | 'PUT' | 'DELETE' = values['method'];

			this.http(
				{
					url: values['urlParams'],
					method: method,
					headers: this.decodeHeaders(),
					data: values["bodyTemplate"]
				}
			).then(result => {
				this.setState({ showPreviewModal: true, response: result.data });
				}).catch(reason => {
					this.setState({ showPreviewModal: true, response: reason.message });
				});

			
			
		}
	}


	private http: Axios.AxiosInstance;

	public componentDidMount() {
		if (this.props.values)
			this.props.values.validate = () => {

				const re = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

				if (!this.props.values['url'])
					return { result: false, errors: "The webhook url  is required for Webhookexecutor. \n" };
				
				if (!this.props.values['method'])
					return { result: false, errors: "The call method is required for WebHookExecutor. \n" };

				return { result: true, errors: "" };
			}
	}

	render() {

		const { values } = this.props;

		const comboValues = [
			{ text: 'GET', value: 'GET' },
			{ text: 'POST', value: 'POST' },
			{ text: 'DELETE', value: 'DELETE' },
			{ text: 'PUT', value: 'PUT' }
		]


		return (
			<React.Fragment>
				<Modal
					style={{ width: '700px' }}
					
					onOk={() => this.setState({ showPreviewModal: false })}
					onCancel={() => this.setState({ showPreviewModal: false })}
					visible={this.state.showPreviewModal}>
					<h3>Response</h3>
					<RadioGroup value={this.state.previewMode} onChange={e => this.setState({ previewMode: e.target.value as any })}>
						<RadioButton value="raw">Raw preview</RadioButton>
						<RadioButton value="html">Html preview</RadioButton>
					</RadioGroup>
					<div>
						{this.state.previewMode == 'raw' && <p style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>{JSON.stringify(this.state.response)}</p>}
						{this.state.previewMode == 'html' && <div dangerouslySetInnerHTML={{ __html: this.state.response.toString() }}></div>}
					</div>
				</Modal>

				<Button onClick={() => this.testWebHook()}>Run</Button>
				<Row gutter={24}>
					<Col xs={24}>
						<p>The Request body and UrlParams  field will be rendered using Razor Engine. The injected viewmodel will be the rule event, watch out the available fields</p>
					</Col>
				</Row>
				<Row gutter={24}>
					<Col xs={8}>
						<TextView
							label='Url'
							required
							placeholder='http(s)://...'
							mode={this.props.mode}
							value={this.state.url}
							onChanged={(e) => {
								this.props.onFieldChange("url", e);
								this.setState({ url: e });
							}}
						/>
					</Col>
					<Col xs={10}>
						<TextView
							label='Url parameters'
							mode={this.props.mode}
							value={this.state.params}
							onChanged={(e) => {
								this.setState({ params: e });
								this.props.onFieldChange("urlParams", e)}
							}
						/>

					</Col>
					<Col xs={6}>
						<div style={{ width: '90px' }}>
							<DropdownView
								label='Method'
								model={values && values["method"]}
								required={true}
								disabled={this.props.mode == 'display'}
								onChanged={(e) => this.props.onFieldChange("method", e.value)}
								options={comboValues}
								keyField='value'
								textField='text'
							/>
						</div>
					</Col>
				</Row>
				<Row gutter={24}>

					<Col xs={24}>
						<HeadersComponent
							label='Headers'
							mode={this.props.mode}
							headers={values["headers"]}
							onHeadersChange={(e) => {
									this.props.onFieldChange("headers", e);
								}
							}
						/>
					</Col>
				</Row>
				<Row gutter={24}>

					<Col xs={24}>
						<TextView
							label='Body'
							rows={10}

							mode={this.props.mode}
							value={this.state.body}
							onChanged={(e) => {
								this.setState({ body: e });
								this.props.onFieldChange("bodyTemplate", e)}
							}
						/>

					</Col>
				</Row>
			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/executors/call-webhook.executor.tsx